import React, { forwardRef, useMemo } from 'react';
import * as PdfViews from './pdf-views';
import CProtal from '../../UI/CPortal';
import { useScheduleContext } from '../../../context/ScheduleContext';
import { isSameAs } from '../../../helpers/times';
import { mappedEpisodes } from '../../../helpers/schedule-helper';
import { PAGES_VIEW_GRID } from '../../../constants/page-settings/schedule';
import ViewWrapper from './components/ViewWrapper';

const PdfType = (props) => {
    const {
        event,
        scheduleFilters,
        pdfSettings,
    } = useScheduleContext();

    const PdfView = PdfViews[props.pdfSettings.view];
    
    function getScheduleByDate(scheduleDate) {
        return mappedEpisodes(event.stream)
            .filter((episode) => isSameAs(episode.timeStart, scheduleDate))
            .filter((episode) => {
                if (episode.delay && !props.pdfSettings.showDelay) {
                    return false;
                }

                return true;
            })
            .sort((a, b) => a.timeStart - b.timeStart);
    }

    return scheduleFilters.scheduleDates.map(({value: scheduleDate}, index) => {
        return (
            <ViewWrapper
                key={index}
                count={index + 1}
                scheduleDate={scheduleDate}
                pdfSettings={pdfSettings}
            >
                <PdfView
                    schedule={getScheduleByDate(scheduleDate)}
                    pdfSettings={pdfSettings}
                    {...props}
                />
            </ViewWrapper>
        )
    });
};

const SchedulePdf = forwardRef((props, ref) => {
    
    return (
        !!props.pdfSettings?.orientation &&
        <CProtal>
            <div
                className="pdf-target"
                style={{
                    width: 0,
                    height: 0,
                    overflow: 'hidden',
                    letterSpacing: '0.3px',
                }}
            >
                <div
                    ref={ref}
                    style={!!props.pdfSettings ?
                        {
                            width: '100%',
                            minWidth: props.pdfSettings.orientation === 'portrait' || props.pdfSettings.view !== PAGES_VIEW_GRID ? 1240 : 1754,
                            backgroundColor: `#${props.pdfSettings.backgroundColor}`,
                            '--pdf-background-color': `#${props.pdfSettings.backgroundColor}`,
                            '--pdf-additional-color': `#${props.pdfSettings.additionalColor}`,
                            '--pdf-text-color': `#${props.pdfSettings.textColor}`,
                            '--pdf-text-additional-color': `#${props.pdfSettings.additionalTextColor}`,
                            '--pdf-border-radius': props.pdfSettings.elementsRoundingSize,
                        }
                        : {
                            width: '100%',
                        }
                    }
                >
                    <PdfType
                        {...props}
                    />
                </div>
            </div>
        </CProtal>
    )
});

export default SchedulePdf;
